export const files = ['Archivo', 'RerGciasfcASujRet', 'RetGcia', 'RetGciaM', 'RetSuss', 'Retib', 'RetibSLUIS', 'RetibTuc', 'Retibbsas', 'Retibcf', 'Retibmis', 'Retiva'];

